const translations = {
    addressLineOne: 'Address Line 1',
    addressLineTwo: 'Address Line 2',
    cancel: 'Cancel',
    city: 'City',
    company: 'Company Name',
    confirm: 'Save',
    email: 'Email',
    emailInvalid: 'Please enter a valid email address.',
    firstName: 'First Name',
    geocodeError: 'Geocoding failed, please correct the address and try again.',
    geocodePartialMatch:
        'Your customer was saved but there was a partial match for the address, please review the address.',
    lastName: 'Last Name',
    phoneInvalid: 'Phone number must be 10 digits.',
    phoneNumber: 'Phone Number',
    saveError: 'An error occurred while saving the customer.',
    saveSuccess: 'Customer saved!',
    saving: 'Saving…',
    selectState: 'Select state',
    state: 'State',
    title: 'Add a new customer',
    zipCode: 'Zip Code'
};

export default translations;
